module.exports = __webpack_public_path__ + "static/clock-bb7dec28742c524ec358a1b0366c51c9.png";